var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrivia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 6C11.0002 6.553 10.5522 7 10.0002 7C9.4482 7 9.0002 6.553 9.0002 6V4C9.0002 3.447 9.4482 3 10.0002 3C10.5522 3 11.0002 3.447 11.0002 4V6ZM17.737 15H17.8C19.013 15 20 14.103 20 13C20 11.96 19.118 11.112 18 11.019V13C18 13.691 17.903 14.359 17.737 15ZM4 13C4 16.309 6.692 19 10 19C13.309 19 16 16.309 16 13V11H4V13ZM17 9H17.8C20.116 9 22 10.794 22 13C22 15.206 20.116 17 17.8 17H17C16.9859 17 16.9729 16.9962 16.96 16.9923C16.9492 16.9891 16.9384 16.9859 16.927 16.985C15.543 19.38 12.96 21 10 21C5.589 21 2 17.411 2 13V10C2 9.447 2.448 9 3 9H17ZM14.0002 7C14.5522 7 15.0002 6.553 15.0002 6V4C15.0002 3.447 14.5522 3 14.0002 3C13.4482 3 13.0002 3.447 13.0002 4V6C13.0002 6.553 13.4482 7 14.0002 7ZM7.0002 6C7.0002 6.553 6.5522 7 6.0002 7C5.4482 7 5.0002 6.553 5.0002 6V4C5.0002 3.447 5.4482 3 6.0002 3C6.5522 3 7.0002 3.447 7.0002 4V6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivia);
export default __webpack_public_path__ + "static/media/Trivia.c4180063.svg";
export { ForwardRef as ReactComponent };